function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1138.27 0H0V627.013H1138.27V0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_7161_73743)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1003.51 468.321V627.775H800.938V472.276L704.378 386.52L733.703 353.529L609.458 241.921H529.49L529.104 264.686L438.332 264.301V309.928L346.113 310.507V286.97H195.147L188.105 279.928V80.2482H437.946V104.364L594.024 104.846C600.101 99.6374 609.748 96.0682 626.629 94.5248C643.51 92.9814 658.655 100.216 658.655 100.216L662.513 78.4154C776.823 65.1034 861.614 113.528 918.045 181.149C922.193 186.069 926.148 191.085 930.007 196.294C935.602 203.818 940.618 211.632 945.248 219.734C963.865 252.821 974.091 290.539 978.914 330.282C980.071 339.735 980.939 349.285 981.518 359.028C983.255 387.099 982.869 415.845 981.229 444.398L1003.51 468.321Z",
  fill: "#FEF6F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M645.341 198.907L643.315 210.29C642.833 213.184 640.036 215.209 637.045 214.631C636.659 214.534 636.274 214.438 635.888 214.245L589.875 194.373C586.691 193.023 585.244 189.261 586.595 186.174C586.884 185.499 587.27 184.92 587.752 184.438L597.109 174.309C598.074 173.248 599.617 172.958 600.968 173.537L641.676 192.058C644.28 193.216 645.824 196.013 645.341 198.907Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M506.242 141.416V160.901C506.242 165.242 502.769 168.811 498.332 168.811C498.043 168.811 497.753 168.811 497.464 168.811L475.084 166.4C470.647 165.917 467.367 162.155 467.367 157.815V140.548L488.203 142.38V139.101L506.242 141.416Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M587.657 124.052L583.413 149.133C582.738 153.184 578.879 155.885 574.828 155.21C574.442 155.113 574.152 155.017 573.766 154.92L556.885 149.422L553.895 133.891H550.808L548.879 120.676L574.924 112.862C580.23 111.319 585.728 114.309 587.368 119.518C587.754 120.965 587.85 122.509 587.657 124.052Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M441.612 130.419V161.673L397.432 164.856V127.718L441.612 130.419Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.291 352.768L859.78 355.179L849.458 397.43L840.969 394.826C840.969 394.826 809.522 394.247 807.882 393.958C806.243 393.668 789.072 373.99 800.551 361.449C812.03 348.909 817.722 363.475 851.291 352.768Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M531.998 76.9778C542.416 70.0324 554.667 66.4632 567.207 66.9456C585.632 67.5243 596.146 72.8298 596.146 72.8298L593.542 92.6049L544.345 107.653L540.969 91.0614L532.384 91.2544L531.998 76.9778Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M766.017 217.525L738.815 246.85L717.979 226.4L731.194 210.001L734.667 212.509L744.795 199.969L766.017 217.525Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M695.601 301.738L690.777 307.14L696.855 312.928L678.816 332.124L671.292 325.854L641.967 358.845L738.43 444.504V600.004H756.855V483.958H782.128V417.495H806.823L803.061 408.62L800.746 410.742L767.08 411.224L722.803 371.289L757.53 331.546L752.996 325.661L713.446 371.385L683.253 343.411L709.781 314.568L695.601 301.738Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.701 231.609L607.527 227.943L599.521 237.59L595.083 234.406L588.91 241.834L575.115 229.583L570.389 234.985L604.44 265.564L620.55 247.815L608.299 237.783L613.701 231.609Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M433.797 202.767V236.722L466.787 236.915L467.077 203.056L433.797 202.767Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M376.209 223.217L418.556 223.313V236.722L376.209 236.529V223.217Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.291 251.384H291.513H283.699L283.796 282.638L330.388 282.059L330.291 251.384Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M335.306 52.6689H325.949V83.4408H335.306V52.6689Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.297 116.141H495.629L495.243 99.8391H518.201V77.4595L479.712 77.2666L479.326 99.3568L488.297 99.8391V116.141Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.121 89.5178L630.584 89.2285L631.163 78.7139H646.211L645.729 48.2314L622.481 48.9067L622.191 84.9841L623.928 85.4664L624.121 89.5178Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M786.756 91.9296L774.506 106.592L762.255 94.9199L755.309 102.83L737.174 87.0099L722.222 104.18L719.039 101.19L722.222 97.8138L721.161 96.7527L744.698 69.6465C759.361 75.8202 773.444 83.3443 786.756 91.9296Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M835.76 245.017L852.738 260.258L815.985 301.158L797.657 286.592L800.744 283.023L784.152 268.168L810.005 239.518L827.272 254.374L833.831 246.946L829.49 243.28L866.339 201.897L853.703 189.839L860.455 182.605L843.092 166.978L855.535 153.473C859.683 158.392 863.638 163.505 867.497 168.617C873.092 176.045 878.108 183.859 882.642 192.058L835.76 245.017Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M707.754 111.223L712.384 115.564L696.854 133.313L704.86 140.355L696.854 149.229L701.677 153.57L686.436 171.512L679.49 165.242L674.281 169.969L665.117 161.094L661.548 164.76L645.053 148.94L675.535 114.309L692.127 128.586L707.754 111.223Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M893.736 394.247L894.122 401.289H919.299L919.685 393.958L893.736 394.247Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M894.701 372.543L920.071 372.253V364.15L894.701 364.343V372.543Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M918.912 331.256L888.237 331.835L888.141 325.95L893.735 326.143V303.185L916.308 302.51C917.466 312.06 918.334 321.61 918.912 331.256Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M850.133 524.087L857.367 522.736V586.692H883.22V600.004H849.168L850.133 524.087Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.111 212.798V236.721H375.918V282.348H330.291V273.28L330.194 251.673L330.098 212.798H376.111Z",
  fill: "#BA7BBA",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M330.195 251.673H307.719V212.798H330.098L330.195 251.673Z",
  fill: "#BA7BBA",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M351.899 212.799H307.719V190.13H351.32V189.938L351.899 212.799Z",
  fill: "#BA7BBA",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.205 126.174L704.858 140.644L696.852 133.698L712.382 115.853L716.819 119.808C718.652 121.447 718.845 124.245 717.205 126.174Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M866.435 201.995L826.403 246.851L818.396 239.905L824.859 233.249V230.838L857.947 193.989L853.799 190.034L851.58 192.445L836.339 178.94L836.049 177.3L833.445 175.082L841.355 165.821L860.455 182.895L843.091 167.268L855.438 153.956C842.898 138.812 828.815 124.921 813.573 112.477C804.892 105.339 795.727 98.6827 786.274 92.6055L774.313 106.882L775.181 107.654L768.525 114.985L755.309 103.216L744.891 94.1489L733.123 107.654C731.579 109.487 728.782 109.68 726.949 108.136L726.853 108.04L722.512 104.085L712.383 115.757L716.82 119.712C718.653 121.352 718.846 124.246 717.206 126.078L704.859 140.548L703.991 141.512L696.756 149.423L701.579 153.763L711.129 143.635L729.071 159.841L723.283 166.207C723.669 166.497 749.136 182.413 762.64 196.014C776.145 209.616 789.747 225.822 789.747 225.822L795.342 219.455L813.477 235.854L809.908 239.712L827.175 254.568L833.734 247.14L829.393 243.474L866.435 201.995ZM798.621 174.214L794.473 178.844C793.219 180.194 791.194 180.291 789.843 179.133L768.911 160.612C767.464 159.262 767.271 157.043 768.621 155.596C768.621 155.5 768.718 155.5 768.718 155.403L773.155 150.966C774.216 149.905 775.856 149.905 776.917 150.869L798.236 169.294C799.779 170.355 799.972 172.67 798.621 174.214C798.621 174.117 798.621 174.117 798.621 174.214Z",
  fill: "#FDC232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M798.621 174.214L794.473 178.844C793.219 180.194 791.194 180.291 789.843 179.133L768.911 160.612C767.464 159.262 767.271 157.043 768.621 155.596C768.621 155.5 768.718 155.5 768.718 155.403L773.155 150.966C774.216 149.905 775.856 149.905 776.917 150.869L798.236 169.294C799.779 170.355 799.972 172.67 798.621 174.214ZM798.621 174.214C798.621 174.117 798.621 174.117 798.621 174.214ZM866.435 201.995L826.403 246.851L818.396 239.905L824.859 233.249V230.838L857.947 193.989L853.799 190.034L851.58 192.445L836.339 178.94L836.049 177.3L833.445 175.082L841.355 165.821L860.455 182.895L843.091 167.268L855.438 153.956C842.898 138.812 828.815 124.921 813.573 112.477C804.892 105.339 795.727 98.6827 786.274 92.6055L774.313 106.882L775.181 107.654L768.525 114.985L755.309 103.216L744.891 94.1489L733.123 107.654C731.579 109.487 728.782 109.68 726.949 108.136L726.853 108.04L722.512 104.085L712.383 115.757L716.82 119.712C718.653 121.352 718.846 124.246 717.206 126.078L704.859 140.548L703.991 141.512L696.756 149.423L701.579 153.763L711.129 143.635L729.071 159.841L723.283 166.207C723.669 166.497 749.136 182.413 762.64 196.014C776.145 209.616 789.747 225.822 789.747 225.822L795.342 219.455L813.477 235.854L809.908 239.712L827.175 254.568L833.734 247.14L829.393 243.474L866.435 201.995Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M744.989 94.148L733.22 107.653C731.677 109.486 728.88 109.679 727.047 108.135L726.95 108.039L722.609 104.084L737.175 87.3955L744.989 94.148Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M798.621 174.213L794.473 178.844C793.219 180.194 791.194 180.29 789.843 179.133L768.91 160.612C767.464 159.261 767.271 157.043 768.621 155.596C768.621 155.499 768.718 155.499 768.718 155.403L773.155 150.966C774.216 149.904 775.856 149.904 776.917 150.869L798.235 169.294C799.779 170.355 799.972 172.67 798.621 174.213C798.621 174.117 798.621 174.117 798.621 174.213Z",
  fill: "#FDC232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M798.621 174.213L794.473 178.844C793.219 180.194 791.194 180.29 789.843 179.133L768.91 160.612C767.464 159.261 767.271 157.043 768.621 155.596C768.621 155.499 768.718 155.499 768.718 155.403L773.155 150.966C774.216 149.904 775.856 149.904 776.917 150.869L798.235 169.294C799.779 170.355 799.972 172.67 798.621 174.213ZM798.621 174.213C798.621 174.117 798.621 174.117 798.621 174.213Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M775.375 107.654L768.719 114.985L755.311 103.12L762.256 95.21L774.41 106.979L774.507 106.882L775.375 107.654Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M729.071 159.936L723.284 166.206L719.714 170.161L701.676 153.763L711.226 143.73L729.071 159.936Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M813.479 235.854L810.006 239.712L804.894 245.211L786.662 229.391L789.749 225.822L795.344 219.455L813.479 235.854Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M866.437 201.995L826.501 246.85L818.494 240.001L824.957 233.249L824.861 230.837L857.948 193.988L866.437 201.995Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M860.456 182.895L853.8 190.13L851.582 192.445L836.34 178.94L836.051 177.3L833.543 175.082L841.357 165.821L860.456 182.895Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M724.345 181.834L701.579 209.037C697.238 214.149 692.222 212.799 687.881 209.905C683.541 207.011 649.971 186.561 644.955 183.956L644.473 183.667L643.701 183.281L665.213 161.287L674.377 170.162L679.586 165.435L704.184 187.622L712.287 178.94L717.496 183.667L720.969 178.94L724.345 181.834Z",
  stroke: "white",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M283.603 184.246L283.699 259.584H132.638L125.596 252.542V52.8623H299.134L299.423 88.168L250.227 87.7821V126.271C245.789 127.236 242.702 131.191 242.702 135.724L243.281 174.792C243.378 180.001 247.622 184.246 252.831 184.246H283.603Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M283.603 184.246L283.699 259.584H132.638L125.596 252.542V52.8623H299.134L299.423 88.168L250.227 87.7821V126.271C245.789 127.236 242.702 131.191 242.702 135.724L243.281 174.792C243.378 180.001 247.622 184.246 252.831 184.246H283.603Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M941.001 440.839V600.293H883.219V586.981H857.367V523.026C889.875 510.1 873.187 473.347 869.618 461.193C866.049 449.038 862.866 410.839 865.856 384.311L887.464 383.829V395.115L893.734 394.537L894.12 401.578H919.2C919.007 406.691 918.814 411.9 918.622 417.013L941.001 440.839Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M941.001 440.839V600.293H883.219V586.981H857.367V523.026C889.875 510.1 873.187 473.347 869.618 461.193C866.049 449.038 862.866 410.839 865.856 384.311L887.464 383.829V395.115L893.734 394.537L894.12 401.578H919.2C919.007 406.691 918.814 411.9 918.622 417.013L941.001 440.839Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M675.825 101.094V114.792L675.536 114.503L645.15 149.133L661.645 164.953L665.214 161.384L643.607 183.281C641.581 182.22 638.494 180.58 634.828 178.555L634.443 178.362L633.767 177.976L633.189 177.686C631.259 176.722 629.233 175.661 627.111 174.6C626.725 174.407 626.243 174.214 625.857 173.924C623.446 172.767 620.938 171.513 618.526 170.452L617.465 169.969L616.114 169.39L615.439 169.101C613.124 168.136 610.905 167.268 608.88 166.593L608.301 166.4L607.24 166.014C595.182 162.349 592.963 156.079 594.314 146.914C594.314 146.914 596.918 129.262 598.944 118.361C600.97 107.461 609.748 99.4544 622.77 98.2004C631.066 97.5251 654.603 97.6216 675.825 101.094Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M675.825 101.094V114.792L675.536 114.503L645.15 149.133L661.645 164.953L665.214 161.384L643.607 183.281C641.581 182.22 638.494 180.58 634.828 178.555L634.443 178.362L633.767 177.976L633.189 177.686C631.259 176.722 629.233 175.661 627.111 174.6C626.725 174.407 626.243 174.214 625.857 173.924C623.446 172.767 620.938 171.513 618.526 170.452L617.465 169.969L616.114 169.39L615.439 169.101C613.124 168.136 610.905 167.268 608.88 166.593L608.301 166.4L607.24 166.014C595.182 162.349 592.963 156.079 594.314 146.914C594.314 146.914 596.918 129.262 598.944 118.361C600.97 107.461 609.748 99.4544 622.77 98.2004C631.066 97.5251 654.603 97.6216 675.825 101.094Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M850.134 524.376L849.169 600.293H756.854V484.247H782.127V417.688H806.822C806.822 417.688 815.021 435.147 816.757 441.9C818.494 448.652 812.32 474.89 809.716 480.292C805.664 488.588 803.253 510.003 820.327 519.746C826.983 523.604 836.532 525.534 850.134 524.376Z",
  fill: "#FC965C",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.066 97.0423L722.127 98.1034L718.944 101.48C716.725 98.8751 714.024 96.7529 711.034 95.306C706.114 92.9908 683.541 93.4732 675.535 92.3156C674.377 92.1227 672.834 91.9297 671.098 91.7368V50.5469C692.898 53.3443 718.172 58.6498 744.699 69.8396L721.066 97.0423Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.12 85.3696V89.7104L593.541 92.6044L596.049 73.0222L599.908 50.9321C607.335 49.6781 614.859 48.8099 622.384 48.5205L622.191 85.1767L624.12 85.3696Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.12 85.3696V89.7104L593.541 92.6044L596.049 73.0223L599.908 50.9321C607.335 49.6781 614.859 48.8099 622.384 48.5205L622.191 85.1767L624.12 85.3696Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M645.921 48.2314C653.734 48.5215 662.706 49.4834 671.87 50.6436L671.869 50.6484C693.494 53.4718 718.484 58.7819 744.699 69.8398L721.065 97.043L722.126 98.1035L718.943 101.48C716.725 98.876 714.023 96.7536 711.033 95.3066C706.114 92.9915 683.541 93.474 675.534 92.3164C674.377 92.1235 672.834 91.9302 671.098 91.7373V91.6123C660.415 90.5551 640.624 89.3203 630.873 89.3203L631.354 78.8789H646.403L645.921 48.2314Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M803.058 408.909L800.743 411.032L767.078 411.514L722.801 371.578L757.528 331.835C776.917 354.793 799.007 399.552 803.058 408.909Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M803.058 408.909L800.743 411.032L767.078 411.514L722.801 371.578L757.528 331.835C776.917 354.793 799.007 399.552 803.058 408.909Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M752.994 325.95L713.347 371.674L683.154 343.699L709.682 314.76L727.045 295.854C727.142 295.854 743.637 313.892 752.994 325.95Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M752.994 325.95L713.347 371.674L683.154 343.699L709.682 314.76L727.045 295.854C727.142 295.854 743.637 313.892 752.994 325.95Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M707.754 111.415L692.223 128.779L675.824 114.792V101.094C688.557 103.119 700.422 106.399 707.754 111.415Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M707.754 111.415L692.223 128.779L675.824 114.792V101.094C688.557 103.119 700.422 106.399 707.754 111.415Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M724.345 181.834L701.579 209.037C697.238 214.149 692.222 212.799 687.881 209.905C683.541 207.011 649.971 186.561 644.955 183.956L644.473 183.667L643.701 183.281L665.213 161.287L674.377 170.162L679.586 165.435L704.184 187.622L712.287 178.94L717.496 183.667L720.969 178.94L724.345 181.834Z",
  fill: "#B0ACD2",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M511.933 139.004L485.791 135.628L485.598 138.618L463.99 137.268V127.621C463.99 127.621 481.257 128.682 491.868 127.621C502.479 126.56 508.267 124.92 510.582 128.2C512.897 131.48 511.933 139.004 511.933 139.004Z",
  fill: "#B0ACD2",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M375.436 52.8623V76.8817H374.182V111.898C366.368 110.451 358.94 108.908 352.381 107.364V52.8623H375.436Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M375.436 52.8623V76.8817H374.182V111.898C366.368 110.451 358.94 108.908 352.381 107.364V52.8623H375.436Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M466.111 77.3631V118.746C460.131 118.553 452.799 118.264 443.539 118.167L443.057 77.2666L466.111 77.3631Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466.111 77.3631V118.746C460.131 118.553 452.799 118.264 443.539 118.167L443.057 77.2666L466.111 77.3631Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M916.308 303.185L893.735 303.57V326.529L888.14 326.336L889.105 375.532H877.819C877.819 375.532 869.33 375.918 869.523 369.552C869.619 367.043 870.487 359.423 871.549 351.223C872.706 341.674 865.954 332.992 856.5 331.834C854.185 331.545 851.774 331.738 849.458 332.413L809.908 344.085C797.754 347.654 784.538 343.217 777.111 332.895C774.313 329.037 770.744 324.503 768.14 321.127L767.561 320.355C767.271 319.873 766.886 319.487 766.596 319.101C762.062 313.217 749.812 298.94 740.358 288.04C733.509 280.033 733.799 268.265 741.033 260.548L774.217 225.339L782.899 233.152L770.551 246.946L788.493 263.249L784.153 268.361L800.744 283.217L797.85 286.593L815.986 301.352L852.738 260.451L835.761 245.21L882.16 192.927C901.452 227.461 911.581 264.213 916.308 303.185Z",
  fill: "#FC8B52",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M551.483 150.29L526.595 145.852C523.991 145.37 522.062 143.151 521.869 140.547L521.193 128.585C521 125.498 523.219 122.797 526.306 122.315C533.058 121.158 539.618 119.228 545.888 116.527L551.483 150.29Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.483 150.29L526.595 145.852C523.991 145.37 522.062 143.151 521.869 140.547L521.193 128.585C521 125.498 523.219 122.797 526.306 122.315C533.058 121.158 539.618 119.228 545.888 116.527L551.483 150.29Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M422.703 178.844V197.75H376.111V212.799H351.899L351.32 189.937L351.417 185.789C351.513 183.763 352.96 182.027 354.986 181.641C365.115 179.712 395.211 174.117 416.723 173.152C419.906 173.056 422.51 175.467 422.703 178.651C422.703 178.747 422.703 178.844 422.703 178.844Z",
  fill: "#B0ACD2",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M556.691 190.708V203.538L546.948 214.438H510.678V186.56H515.501V180.193C529.392 182.894 543.186 186.367 556.691 190.708Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556.691 190.708V203.538L546.948 214.438H510.678V186.56H515.501V180.193C529.392 182.894 543.186 186.367 556.691 190.708Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M466.981 203.345L433.701 203.056V177.493C433.701 174.792 435.823 172.67 438.524 172.573C448.267 172.573 457.624 172.959 466.692 173.634L466.981 203.345Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466.981 203.345L433.701 203.056V177.493C433.701 174.792 435.823 172.67 438.524 172.573C448.267 172.573 457.624 172.959 466.692 173.634L466.981 203.345Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.679 186.464V214.342H466.981V206.528V203.249L466.691 173.441C480.196 174.406 492.93 176.046 504.505 178.072V186.464H510.679Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510.679 186.464V214.342H466.981V206.528V203.249L466.691 173.441C480.196 174.406 492.93 176.046 504.505 178.072V186.464H510.679Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M609.747 225.531L599.425 237.782L594.988 234.599L588.814 242.123L575.117 229.776L570.293 235.177L547.142 214.341H546.949L556.692 203.441V190.611C567.592 194.18 574.152 196.978 574.924 197.557C577.528 199.486 579.457 209.518 581.194 212.026C582.93 214.534 600.39 219.84 609.747 225.531Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.747 225.531L599.425 237.782L594.988 234.599L588.814 242.123L575.117 229.776L570.293 235.177L547.142 214.341H546.949L556.692 203.441V190.611C567.592 194.18 574.152 196.978 574.924 197.557C577.528 199.486 579.457 209.518 581.194 212.026C582.93 214.534 600.39 219.84 609.747 225.531Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M659.33 239.037L621.709 281.385L604.346 265.854L620.455 248.105L608.204 238.073L616.211 229.005C621.516 233.925 631.548 226.015 636.565 226.497C639.073 226.69 649.491 232.671 659.33 239.037Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M659.33 239.037L621.709 281.385L604.346 265.854L620.455 248.105L608.204 238.073L616.211 229.005C621.516 233.925 631.548 226.015 636.565 226.497C639.073 226.69 649.491 232.671 659.33 239.037Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M672.448 294.6C670.326 299.037 660.969 307.912 656.242 312.253L621.805 281.288L659.329 238.94V238.844C668.686 244.921 677.464 251.288 678.139 253.217C679.297 257.365 675.342 288.619 672.448 294.6Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.448 294.6C670.326 299.037 660.969 307.912 656.242 312.253L621.805 281.288L659.329 238.94V238.844C668.686 244.921 677.464 251.288 678.139 253.217C679.297 257.365 675.342 288.619 672.448 294.6Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.423 88.0717V83.7308L310.42 83.4414V119.519C310.42 123.088 307.526 125.982 303.957 125.982H252.349C251.674 125.982 250.902 126.078 250.227 126.175V87.7823L299.423 88.0717Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.423 88.0717V83.7308L310.42 83.4414V119.519C310.42 123.088 307.526 125.982 303.957 125.982H252.349C251.674 125.982 250.902 126.078 250.227 126.175V87.7823L299.423 88.0717Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.284 52.8623V107.461C336.464 103.892 325.467 100.901 325.467 100.901V83.5377H335.21V52.8623H352.284Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.284 52.8623V107.461C336.464 103.892 325.467 100.901 325.467 100.901V83.5377H335.21V52.8623H352.284Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.298 76.9783V115.757C390.195 114.696 381.995 113.345 374.182 111.898V76.8818H375.436L396.561 76.9783H398.298Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.298 76.9783V115.757C390.195 114.696 381.995 113.345 374.182 111.898V76.8818H375.436L396.561 76.9783H398.298Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.201 99.9367V118.94C485.308 119.712 479.327 119.326 466.111 118.747V77.3643L479.713 77.4607L479.327 99.5509L488.201 99.9367Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.201 99.9367V118.94C485.308 119.712 479.327 119.326 466.111 118.747V77.3643L479.713 77.4607L479.327 99.5509L488.201 99.9367Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.538 118.167C438.908 118.071 433.892 118.071 428.394 117.975C418.361 117.878 408.233 117.106 398.297 115.756V76.9775L443.152 77.1705L443.538 118.167Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.538 118.167C438.908 118.071 433.892 118.071 428.394 117.975C418.361 117.878 408.233 117.106 398.297 115.756V76.9775L443.152 77.1705L443.538 118.167Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M511.545 100.033V116.336C505.661 117.397 500.066 118.072 495.629 118.458L495.146 100.033H511.545Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M511.545 100.033V116.336C505.661 117.397 500.066 118.072 495.629 118.458L495.146 100.033H511.545Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M544.344 107.749C537.399 111.029 523.798 114.309 511.547 116.431V100.129H518.106V77.6528L531.033 77.7492C531.033 77.7492 531.322 77.4599 531.997 76.9775L532.383 91.3506L540.968 91.1577L544.344 107.749Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M544.344 107.749C537.399 111.029 523.798 114.309 511.547 116.431V100.129H518.106V77.6528L531.033 77.7492C531.033 77.7492 531.322 77.4599 531.997 76.9775L532.383 91.3506L540.968 91.1577L544.344 107.749Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.141 295.854L709.777 314.761L686.047 293.346C682.864 284.954 699.938 281.577 707.366 280.516C709.681 280.227 711.996 280.902 713.732 282.542C718.556 286.979 727.141 295.854 727.141 295.854Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.141 295.854L709.777 314.761L686.047 293.346C682.864 284.954 699.938 281.577 707.366 280.516C709.681 280.227 711.996 280.902 713.732 282.542C718.556 286.979 727.141 295.854 727.141 295.854Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M381.996 144.02L352.768 144.117V115.563C354.986 116.046 357.012 116.432 358.555 116.625C362.993 117.3 368.395 118.168 372.832 118.843C377.945 119.615 381.707 124.052 381.803 129.165L381.996 144.02Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M381.996 144.02L352.768 144.117V115.563C354.986 116.046 357.012 116.432 358.555 116.625C362.993 117.3 368.395 118.168 372.832 118.843C377.945 119.615 381.707 124.052 381.803 129.165L381.996 144.02Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.767 115.563V144.116L321.898 144.213L322.091 120.29C322.188 114.888 326.529 110.547 331.931 110.643C332.702 110.643 333.571 110.74 334.342 110.933C340.323 112.572 347.365 114.405 352.767 115.563Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.767 115.563V144.116L321.898 144.213L322.091 120.29C322.188 114.888 326.529 110.547 331.931 110.643C332.702 110.643 333.571 110.74 334.342 110.933C340.323 112.572 347.365 114.405 352.767 115.563Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.767 144.213V174.406L334.632 177.3C328.555 178.265 322.767 174.117 321.802 168.039C321.706 167.364 321.61 166.785 321.706 166.11L321.899 144.309L352.767 144.213Z",
  fill: "#FDC232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.767 144.213V174.406L334.632 177.3C328.555 178.265 322.767 174.117 321.802 168.039C321.706 167.364 321.61 166.785 321.706 166.11L321.899 144.309L352.767 144.213Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.285 160.034C382.382 165.532 378.427 170.355 372.928 171.223L352.768 174.407V144.214L381.996 144.117L382.285 160.034Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.285 160.034C382.382 165.532 378.427 170.355 372.928 171.223L352.768 174.407V144.214L381.996 144.117L382.285 160.034Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M572.704 171.898L571.643 178.554C571.064 182.027 567.784 184.438 564.215 183.86C563.926 183.763 563.636 183.763 563.347 183.667C557.463 181.834 549.456 179.326 545.115 178.072L550.807 158.2C556.594 159.551 562.382 161.094 567.012 162.541C570.967 163.892 573.379 167.847 572.704 171.898Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572.704 171.898L571.643 178.554C571.064 182.027 567.784 184.438 564.215 183.86C563.926 183.763 563.636 183.763 563.347 183.667C557.463 181.834 549.456 179.326 545.115 178.072L550.807 158.2C556.594 159.551 562.382 161.094 567.012 162.541C570.967 163.892 573.379 167.847 572.704 171.898Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M550.903 158.296L545.212 178.168L545.019 178.071C540.678 176.817 533.251 175.467 527.945 174.502C524.376 173.924 521.771 170.74 521.868 167.171L521.964 158.779C521.964 155.692 524.472 153.28 527.559 153.377C527.849 153.377 528.234 153.377 528.524 153.473C534.119 154.534 542.607 156.271 550.903 158.296Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550.903 158.296L545.212 178.168L545.019 178.071C540.678 176.817 533.251 175.467 527.945 174.502C524.376 173.924 521.771 170.74 521.868 167.171L521.964 158.779C521.964 155.692 524.472 153.28 527.559 153.377C527.849 153.377 528.234 153.377 528.524 153.473C534.119 154.534 542.607 156.271 550.903 158.296Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M687.785 227.365L680.261 236.818C678.428 239.037 675.245 239.616 672.834 237.976L656.724 227.268C654.216 225.628 653.059 222.541 653.927 219.648C654.313 218.201 654.698 216.561 655.084 214.824C655.374 213.088 655.567 211.255 655.759 209.422C655.952 206.336 658.653 204.02 661.74 204.213C662.705 204.31 663.573 204.599 664.441 205.082L686.628 219.551C689.039 221.191 689.715 224.471 688.075 226.979C687.978 227.172 687.882 227.268 687.785 227.365Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M687.785 227.365L680.261 236.818C678.428 239.037 675.245 239.616 672.834 237.976L656.724 227.268C654.216 225.628 653.059 222.541 653.927 219.648C654.313 218.201 654.698 216.561 655.084 214.824C655.374 213.088 655.567 211.255 655.759 209.422C655.952 206.336 658.653 204.02 661.74 204.213C662.705 204.31 663.573 204.599 664.441 205.082L686.628 219.551C689.039 221.191 689.715 224.471 688.075 226.979C687.978 227.172 687.882 227.268 687.785 227.365Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M726.371 259.391L718.654 267.398C716.531 269.616 713.059 269.809 710.744 267.88L688.268 249.359C685.952 247.526 685.663 244.15 687.496 241.835L694.924 232.574C696.853 230.163 700.422 229.777 702.93 231.706C702.93 231.706 703.026 231.706 703.026 231.803L726.081 251.095C728.493 253.121 728.782 256.69 726.757 259.102C726.564 259.198 726.564 259.295 726.371 259.391Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M726.371 259.391L718.654 267.398C716.531 269.616 713.059 269.809 710.744 267.88L688.268 249.359C685.952 247.526 685.663 244.15 687.496 241.835L694.924 232.574C696.853 230.163 700.422 229.777 702.93 231.706C702.93 231.706 703.026 231.706 703.026 231.803L726.081 251.095C728.493 253.121 728.782 256.69 726.757 259.102C726.564 259.198 726.564 259.295 726.371 259.391Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M787.431 97.4277L771.129 117.106L831.129 172.862L850.422 152.701C850.422 152.701 830.936 132.058 820.036 122.122C808.171 111.318 787.431 97.4277 787.431 97.4277Z",
  fill: "#FD9E06",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M876.082 483.861H940.906",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M820.326 519.745V546.176H757.143",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M386.338 176.335V197.75",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M811.88 161.883L802.62 171.617",
  stroke: "white",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M748 158L736.237 167.733",
  stroke: "white",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M834.78 236L825.001 247",
  stroke: "white",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M861.779 230.999L871 239",
  stroke: "white",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M875.001 217.77L884.223 225.771",
  stroke: "white",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M821.497 170L812.237 179.733",
  stroke: "white",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M883.001 182L873.001 191",
  stroke: "white",
  strokeWidth: 0.5
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M352.5 158V144.5H322V160.5L352.5 158Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M352.5 174.5V158.5L322 160.5L321.5 169C321.9 174.6 330.333 177.5 333.5 177.5L352.5 174.5Z",
  fill: "#F7BD9B",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 249.84,
  y: 136.014,
  width: 58.8428,
  height: 39.5501,
  rx: 10,
  fill: "#FC965C"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7161_73743"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1138.27,
  height: 627.013,
  fill: "white"
})));

function SvgMapF3202605(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1139,
    height: 628,
    viewBox: "0 0 1139 628",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7161_73743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7161_73743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1139,
    height: 628
  }, _ref2), _ref3, _ref4, _ref5, _ref6), _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapF3202605);
export default __webpack_public_path__ + "static/media/map_f3_2026_05.3a2a24e6.svg";
export { ForwardRef as ReactComponent };